export default __webpack_public_path__ + "static/media/wfh-template-image.1dbf5aaf.svg";